import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import {
  pushPath,
  replaceTop,
  readStack,
  writeStack,
} from "../models/navStack";

export function useAutoNavStack() {
  const { pathname, search, hash } = useLocation();
  const navType = useNavigationType(); // "PUSH" | "REPLACE" | "POP"
  const current = pathname + search + hash;

  const prevRef = useRef<string | null>(null);

  useEffect(() => {
    if (prevRef.current === null) {
      const stack = readStack();
      if (stack.length === 0) writeStack([current]);
      else replaceTop(current);
      prevRef.current = current;
      return;
    }

    if (navType === "PUSH") {
      pushPath(current);
    } else if (navType === "REPLACE") {
      replaceTop(current);
    } else {
      replaceTop(current);
    }

    prevRef.current = current;
  }, [current, navType]);
}
